import { BusinessHoursSummary } from "@/components/org/settings/BusinessHoursSummary";

export const OperationsSection = ({ form }) => (
  <BusinessHoursSummary hours={form.business_hours_structured} />
);
